/**
 * Data object representing the application parameters list item
 * @note This is usually used in data table as a row. Params don't have default values since this data object is used to
 * represent data that actually exists.
 */
export class ApplicationParametersListItemDataObject {
	/**
	 * @param {string} id - List item's ID.
	 * @param {string} applicationName - List item's application name.
	 * @param {string} paramName - List item's parameter name.
	 * @param {string} paramValue - List item's parameter value.
	 */
	constructor(id, applicationName, paramName, paramValue) {
		this.id = id;
		this.applicationName = applicationName;
		this.paramName = paramName;
		this.paramValue = paramValue;
	}
}

/**
 * Data object representing the application parameters item
 * @note This is usually used when creating or updating data table item using a popup or a dialog. Params have default 
 * values since this data object can be used for creating an item. This is why 'id' has a default value of null which 
 * represents a new item that is being created.
 */
export class ApplicationParametersItemDataObject {
	/**
	 * @param {string|null} [id=null] - Item's ID.
	 * @param {string} [applicationName=''] - Item's application name.
	 * @param {string} [paramName=''] - Item's parameter name.
	 * @param {string} [paramValue=''] - Item's parameter value.
	 */
	constructor(id = null, applicationName = '', paramName = '', paramValue = '') {
		this.id = id;
		this.applicationName = applicationName;
		this.paramName = paramName;
		this.paramValue = paramValue;
	}
}